import React from 'react'
import { View, ActivityIndicator } from 'react-native'
// import CircleSnail from 'react-native-progress/CircleSnail'
// import Icon from 'react-native-vector-icons/Feather'
import { DateTime } from 'luxon'

import tw from 'tailwind-rn'
import styles from './styles'
// import * as colors from '../../config/colors'
import { HGText } from '../../components/HGUI'
import { Markdown } from '../../components/Content/index'
import { NewsItemType } from '../../config/types'
// import newsStylesheet from './newsStylesheet'

type Props = {
  newsArticle: NewsItemType
}

const NewsArticle = (props: Props) => {
  const { newsArticle } = props
  const { title, text: body, date } = newsArticle
  const formattedDate = `${DateTime.fromISO(date).toFormat(
    'dd.LL.yyyy HH:mm'
  )} Uhr`

  return (
    <View>
      {body && (
        <View>
          <View style={tw('pt-6 px-3')}>
            <HGText bold style={tw('text-2xl mb-2')}>
              {title}
            </HGText>
            <HGText style={styles.newsDateText}>{formattedDate}</HGText>
          </View>

          <View style={tw('mt-2 px-3')}>
            <Markdown>{body}</Markdown>
          </View>
        </View>
      )}
    </View>
  )
}

export default NewsArticle
